/**
 * Minimal first-party cookie helper. No external dependency (js-cookie) is
 * pulled in since the app only needs get/set/remove for a couple of cookies.
 */

const secureFlag = () =>
  typeof window !== 'undefined' && window.location.protocol === 'https:'
    ? '; Secure'
    : '';

export const setCookie = (name, value, days) => {
  if (typeof document === 'undefined') return;
  const expires = new Date(
    Date.now() + days * 24 * 60 * 60 * 1000,
  ).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(
    value,
  )}; expires=${expires}; path=/; SameSite=Lax${secureFlag()}`;
};

export const getCookie = (name) => {
  if (typeof document === 'undefined') return null;
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`));
  if (!match) return null;
  try {
    return decodeURIComponent(match.slice(name.length + 1));
  } catch {
    return null;
  }
};

export const removeCookie = (name) => {
  if (typeof document === 'undefined') return;
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax${secureFlag()}`;
};
